import type { ReactNode } from "react";

/**
 * Page header shared by the shell pages: optional eyebrow line (a copy key the
 * brand sets, rendered as real text so it is read and translatable), title,
 * optional subtitle, then any controls.
 */
export function PageHead({ eyebrow, title, sub, children, className }: { eyebrow?: string; title: ReactNode; sub?: ReactNode; children?: ReactNode; className?: string }) {
  return (
    <header className={`page-head${eyebrow ? " has-eyebrow" : ""}${className ? ` ${className}` : ""}`}>
      {eyebrow && <p className="page-eyebrow">{eyebrow}</p>}
      <h1>{title}</h1>
      {sub && <p className="page-sub">{sub}</p>}
      {children}
    </header>
  );
}
